import React from "react";
import { useIntl } from "@leagueplatform/locales";
import { usePageViewAnalytics } from "@leagueplatform/analytics";
import { useDocumentTitle } from "@leagueplatform/web-common";
import { Masonry } from "@leagueplatform/masonry";
import { MASONRY } from "common/constants";
import { PageContentWrapper } from "components/page-content-wrapper.component";
import { PageHeader } from "components/page-header/page-header.component";

export const PhysicalResultsDownloadFormPage = () => {
  usePageViewAnalytics({
    screen_name: "Physician Results Form - Download",
  });
  const { formatMessage } = useIntl();
  useDocumentTitle(formatMessage({ id: "STR_PHYSICIAN_RESULTS_FORM" }));

  return (
    <PageContentWrapper>
      <PageHeader
        variant="sub-page"
        mobileBand="green"
        headingText={formatMessage({ id: "STR_PHYSICIAN_RESULTS_FORM" })}
      />
      <Masonry
        rootNodeId={MASONRY.ROOT_NODE_ID_PHYSICIAN_RESULTS_DOWNLOAD_FORM}
      />
    </PageContentWrapper>
  );
};
